/* Service Worker */
/*------------------------------------------------------------*/
// self.addEventListener('fetch', () => { });
/*------------------------------------------------------------*/
self.addEventListener('push', (e) => {
    const event = e as PushEvent;
    const title = 'New Message';
    const body = event.data?.text();
    const _self = self as unknown as ServiceWorkerGlobalScope;
    _self.registration.showNotification(title, { body: body });
});
/*------------------------------------------------------------*/